import TrialVipsApp from './VipsApp';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const VipsAppConfig = {
    settings: {
        layout: {
            config: {
                footer : {
                    display: false
                }
            }
        }
    },
    auth: [...authRoles.cc, ...authRoles.admin], //  ['cc']
    routes: [
        {
            path: '/apps/vip/:id',
            component: TrialVipsApp
        },
        {
            path: '/apps/vip',
            component: () => <Redirect to="/apps/vip/all"/>
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/VipsAppConfig.js